var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("BjPage", {
    ref: "BjPage",
    attrs: {
      "query-params": _vm.queryParams,
      "col-span": _vm.colSpan,
      "label-width": "80px",
      "get-action": _vm.queryApi,
      serial: _vm.serial,
      selection: _vm.selection,
    },
    on: {
      handleSelectionChange: _vm.handleSelectionChange,
      showSetting: _vm.SortableTable.show,
      "header-dragend": _vm.SortableTable.handleHeaderDragend,
      "header-contextmenu": _vm.SortableTable.handleHeaderContextmenu,
    },
    scopedSlots: _vm._u([
      {
        key: "baseForm",
        fn: function () {
          return [
            _c(
              "el-col",
              { attrs: { span: _vm.colSpan } },
              [
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: _vm.$t("goodsPage.productTypes"),
                      prop: "type",
                    },
                  },
                  [
                    _c("BjSelectLov", {
                      attrs: {
                        "option-list": _vm.GOODS_TYPE_LIST,
                        placeholder: _vm.$t("chooseText"),
                      },
                      model: {
                        value: _vm.queryParams.type,
                        callback: function ($$v) {
                          _vm.$set(_vm.queryParams, "type", $$v)
                        },
                        expression: "queryParams.type",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "el-col",
              { attrs: { span: _vm.colSpan } },
              [
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: _vm.$t("goodsPage.categoryName"),
                      prop: "categoryIdList",
                    },
                  },
                  [
                    _c("BjGoodsTypeTreeSelect", {
                      attrs: { limit: 1, multiple: "" },
                      model: {
                        value: _vm.queryParams.categoryIdList,
                        callback: function ($$v) {
                          _vm.$set(_vm.queryParams, "categoryIdList", $$v)
                        },
                        expression: "queryParams.categoryIdList",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ]
        },
        proxy: true,
      },
      {
        key: "tableOperation",
        fn: function () {
          return [
            _vm.setFlag == _vm.GOODS_COMBO_TYPES.ORDINARY
              ? _c(
                  "el-col",
                  [
                    _c(
                      "el-button",
                      {
                        directives: [
                          {
                            name: "permission",
                            rawName:
                              "v-permission:BusinessGoodsSpuOrdinary_DownloadTemplate",
                            arg: "BusinessGoodsSpuOrdinary_DownloadTemplate",
                          },
                        ],
                        attrs: { type: "primary", disabled: "" },
                        on: { click: _vm.onDownload },
                      },
                      [_vm._v(_vm._s(_vm.$t("downloadTemplateText")))]
                    ),
                    _c(
                      "el-button",
                      {
                        directives: [
                          {
                            name: "permission",
                            rawName:
                              "v-permission:BusinessGoodsSpuOrdinary_ImportData",
                            arg: "BusinessGoodsSpuOrdinary_ImportData",
                          },
                        ],
                        attrs: { type: "primary", disabled: "" },
                        on: { click: _vm.onLead },
                      },
                      [_vm._v(_vm._s(_vm.$t("importDataText")))]
                    ),
                    _c(
                      "el-button",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value:
                              _vm.setFlag == _vm.GOODS_COMBO_TYPES.ORDINARY,
                            expression: "setFlag == GOODS_COMBO_TYPES.ORDINARY",
                          },
                          {
                            name: "permission",
                            rawName: "v-permission:BusinessGoodsSpuOrdinaryAdd",
                            arg: "BusinessGoodsSpuOrdinaryAdd",
                          },
                        ],
                        staticClass: "main-btn",
                        attrs: { type: "primary" },
                        on: { click: _vm.onAdd },
                      },
                      [
                        _vm._v(
                          " " + _vm._s(_vm.$t("goodsPage.generalMerchandise"))
                        ),
                      ]
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _vm.setFlag == _vm.GOODS_COMBO_TYPES.PACKAGE
              ? _c(
                  "el-col",
                  [
                    _c(
                      "el-button",
                      {
                        directives: [
                          {
                            name: "permission",
                            rawName:
                              "v-permission:BusinessGoodsSpuPackage_DownloadTemplate",
                            arg: "BusinessGoodsSpuPackage_DownloadTemplate",
                          },
                        ],
                        attrs: { type: "primary", disabled: "" },
                        on: { click: _vm.onDownload },
                      },
                      [_vm._v(_vm._s(_vm.$t("downloadTemplateText")))]
                    ),
                    _c(
                      "el-button",
                      {
                        directives: [
                          {
                            name: "permission",
                            rawName:
                              "v-permission:BusinessGoodsSpuPackage_ImportData",
                            arg: "BusinessGoodsSpuPackage_ImportData",
                          },
                        ],
                        attrs: { type: "primary", disabled: "" },
                        on: { click: _vm.onLead },
                      },
                      [_vm._v(_vm._s(_vm.$t("importDataText")))]
                    ),
                    _c(
                      "el-button",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.setFlag == _vm.GOODS_COMBO_TYPES.PACKAGE,
                            expression: "setFlag == GOODS_COMBO_TYPES.PACKAGE",
                          },
                          {
                            name: "permission",
                            rawName: "v-permission:BusinessGoodsSpuPackageAdd",
                            arg: "BusinessGoodsSpuPackageAdd",
                          },
                        ],
                        staticClass: "main-btn",
                        attrs: { type: "primary" },
                        on: { click: _vm.onAdd },
                      },
                      [_vm._v(" " + _vm._s(_vm.$t("goodsPage.packageProduct")))]
                    ),
                  ],
                  1
                )
              : _vm._e(),
          ]
        },
        proxy: true,
      },
      {
        key: "tableColumn",
        fn: function () {
          return [
            _vm._l(_vm.dropCols, function (col, index) {
              return [
                col.prop !== "bjTableAction"
                  ? _c("el-table-column", {
                      key:
                        "col_" +
                        index +
                        "_" +
                        col.prop +
                        "_" +
                        (col.width || "auto"),
                      attrs: {
                        prop: col.prop,
                        label: col.label,
                        width: col.width || "auto",
                        fixed: col.fixed || false,
                        align: "center",
                        "class-name": "item",
                        "show-overflow-tooltip": "",
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                col.prop === "code"
                                  ? _c(
                                      "span",
                                      {
                                        staticClass: "link",
                                        on: {
                                          click: function ($event) {
                                            return _vm.onView(scope.row)
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(scope.row[col.prop]) +
                                            " "
                                        ),
                                      ]
                                    )
                                  : col.prop == "mainImage"
                                  ? _c(
                                      "div",
                                      { staticClass: "flex flex-spacearound" },
                                      [
                                        _c("BjViewUrl", {
                                          staticStyle: { width: "90px" },
                                          attrs: {
                                            url: scope.row[col.prop][0],
                                          },
                                        }),
                                      ],
                                      1
                                    )
                                  : col.prop == "type"
                                  ? _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            _vm.GOODS_TYPE_LIST.bjGet(
                                              scope.row[col.prop]
                                            )
                                          )
                                        ) + " "
                                      ),
                                    ])
                                  : col.prop === "status"
                                  ? _c(
                                      "el-tag",
                                      {
                                        attrs: {
                                          type: scope.row.status
                                            ? "success"
                                            : "info",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              _vm.STATUS_ENABLED_NUM.bjGet(
                                                scope.row[col.prop]
                                              )
                                            )
                                          )
                                        ),
                                      ]
                                    )
                                  : _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm._f("timeFilters")(
                                            scope.row[col.prop],
                                            scope.row[col.prop]
                                          )
                                        )
                                      ),
                                    ]),
                              ]
                            },
                          },
                        ],
                        null,
                        true
                      ),
                    })
                  : _vm._e(),
                col.prop === "bjTableAction"
                  ? _c("el-table-column", {
                      key:
                        "col_" +
                        index +
                        "_" +
                        col.prop +
                        "_" +
                        (col.width || "auto"),
                      attrs: {
                        prop: col.prop,
                        label: col.label,
                        width: col.width || "auto",
                        fixed: col.fixed || "right",
                        align: "center",
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (props) {
                              return [
                                _c(
                                  "el-button",
                                  {
                                    directives: [
                                      {
                                        name: "permission",
                                        rawName:
                                          "v-permission:BusinessGoodsSpuOrdinaryView",
                                        arg: "BusinessGoodsSpuOrdinaryView",
                                      },
                                    ],
                                    attrs: { type: "text" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.onView(props.row)
                                      },
                                    },
                                  },
                                  [_vm._v(_vm._s(_vm.$t("viewText")))]
                                ),
                                _c(
                                  "el-button",
                                  {
                                    directives: [
                                      {
                                        name: "permission",
                                        rawName:
                                          "v-permission:BusinessGoodsSpuOrdinaryEdit",
                                        arg: "BusinessGoodsSpuOrdinaryEdit",
                                      },
                                    ],
                                    staticClass: "edit-btn",
                                    attrs: {
                                      disabled: props.row.todo1 == 2,
                                      type: "text",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.onEdit(props.row)
                                      },
                                    },
                                  },
                                  [_vm._v(_vm._s(_vm.$t("editText")))]
                                ),
                                _c(
                                  "el-button",
                                  {
                                    directives: [
                                      {
                                        name: "permission",
                                        rawName:
                                          "v-permission:BusinessGoodsSpuOrdinary_Status",
                                        arg: "BusinessGoodsSpuOrdinary_Status",
                                      },
                                    ],
                                    attrs: { type: "text" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.onStatus(props.row)
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        props.row.status
                                          ? _vm.$t("disableText")
                                          : _vm.$t("enableText")
                                      )
                                    ),
                                  ]
                                ),
                                _c(
                                  "el-button",
                                  {
                                    directives: [
                                      {
                                        name: "permission",
                                        rawName:
                                          "v-permission:BusinessGoodsSpuOrdinary_Delete",
                                        arg: "BusinessGoodsSpuOrdinary_Delete",
                                      },
                                    ],
                                    staticClass: "delete-btn",
                                    attrs: { type: "text" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.onDelete(props.row)
                                      },
                                    },
                                  },
                                  [_vm._v(_vm._s(_vm.$t("delText")))]
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        true
                      ),
                    })
                  : _vm._e(),
              ]
            }),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }